export const APP_GTM_ID = process.env.REACT_APP_GTM_ID ?? '';
